import { ServerVars } from 'server-vars';
import { ABConfig } from './types/abTesting';

const CONTROL = 'CONTROL';
const VARIANT = 'VARIANT';
const INELIGIBLE = 'INELIGIBLE';

export const AB_TYPES: {
    CONTROL: typeof CONTROL;
    VARIANT: typeof VARIANT;
    INELIGIBLE: typeof INELIGIBLE;
} = { CONTROL, VARIANT, INELIGIBLE };

export type AB_TYPE = typeof CONTROL | typeof VARIANT | typeof INELIGIBLE;

/**
 * Return the A/B configuration
 */
export const getConfig = (serverVars: ServerVars): ABConfig => {
    return serverVars.get('abTestConfig') || {};
};

export const getPageType = (serverVars: ServerVars): string => {
    return serverVars.get('settings').pageType || '';
};
